import React, { FunctionComponent } from 'react'
import BasicRowItem from '../RowItem/BasicRowItem'

type DisplayProp = 'none' | 'flex'
type Props = {
    display?: DisplayProp | DisplayProp[]
    width: string | number | string[] | number[]
}

const HeaderItem: FunctionComponent<Props> = ({ display, children, width }) => (
    <BasicRowItem display={display} marginX={[1, 1, 12, 16]} width={width}>
        {children}
    </BasicRowItem>
)

export default HeaderItem
